import { motion } from "framer-motion";
import { AlertTriangle, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PendingLeadsBanner = ({ huntPending, farmPending, onView, onDismissAll }) => (
  <motion.div
    initial={{ opacity: 0, y: -10 }}
    animate={{ opacity: 1, y: 0 }}
    className="mb-4 p-3 rounded-lg bg-amber-500/10 border border-amber-500/30 flex flex-wrap items-center justify-between gap-2 relative z-10"
  >
    <div className="flex items-center gap-3">
      <AlertTriangle className="h-5 w-5 text-amber-400" />
      <div>
        <p className="text-sm text-gray-300">
          {huntPending > 0 && `${huntPending} Hunt leads need disposition`}
          {huntPending > 0 && farmPending > 0 && " • "}
          {farmPending > 0 && `${farmPending} Farm leads need disposition`}
        </p>
        <p className="text-xs text-gray-500">Save or dismiss leads before generating new ones</p>
      </div>
    </div>
    <div className="flex items-center gap-2 flex-shrink-0">
      <Button onClick={onView} size="sm" className="bg-amber-500/20 hover:bg-amber-500/30 text-amber-400 border border-amber-500/40" data-testid="view-pending-leads-btn">
        <Eye className="h-4 w-4 mr-1" />
        View Leads
      </Button>
      <Button onClick={onDismissAll} size="sm" variant="ghost" className="text-gray-500 hover:text-red-400 text-xs" data-testid="dismiss-all-leads-btn">
        Dismiss All
      </Button>
    </div>
  </motion.div>
);
